
import { Component, Prop, Vue } from 'vue-property-decorator';
import { faultList } from '@/api/fault';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'GroupFault',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Array,
    default: () => []
  })
  selectFault!: any;

  @Prop({
     default: '2'
   })
  faultType!: string;

  @Prop({
     type: Boolean,
     default: true
   })
  isMulti!: Boolean;

  @Prop({
     type: Boolean,
     default: false
   })
  showThree!: Boolean;

  private faultTypeName = "";
  private listLoading = false;

  private faultSearch: any = {
    name: ''
  }
  private currentPage: number =1;
  private totalPage:number=1;
  //传来的数据 selectFault 及所有的选中
  private faultTopMultipleSelection:any=[]
  private faultSelectedAll = false
  private isIndeterminate: any = null
  //表格选中的数据 
  private faultSelected: any = []
  private faultTableData: any = []

  private dialogResult: any = {}

  created() {
    this.faultTopMultipleSelection = this.selectFault;
    this.getList();
    this.faultTypeName =  this.faultType==='2'?'故障现象':'故障类型'
  }
  private getList() {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.currentPage,
      size: 10,
      fault_name: this.faultSearch.name,
      type: this.faultType
    };
    faultList(params)
      .then((res) => {
        if (res.data) {
          if (this.currentPage === 1) {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].pname = '';
              if (res.data.list[i].child) {
                for (let m = 0; m < res.data.list[i].child.length; m++) {
                  res.data.list[i].child[m].pname = res.data.list[i].name;
                }
              }
            }
            this.faultTableData = res.data.list;
          } else {
            this.faultTableData = this.faultTableData.concat(res.data.list);
          }
          this.totalPage = parseInt(res.data.page_count);
          this.setSelect(this.faultTableData);
        } else {
          if (this.currentPage === 1) {
            this.faultTableData = [];
          }
        }
        this.listLoading = false;
      })
      .catch((err) => {
        this.faultTableData = [];
        this.listLoading = false;
        let msg = err.msg;
      });
  }
  private loadMore() {
    this.currentPage = this.currentPage + 1;
    this.getList();
  }
  private setSelect(list: any) {
    if (this.selectFault && this.selectFault.length > 0) {
      for (let i = 0; i < this.selectFault.length; i++) {
        let item: any = this.selectFault[i];
        for (let m = 0; m < list.length; m++) {
          let element: any = list[m];
          if (element.id === item.id) {
            let arr = this.faultSelected.filter((v: any) => {
              return v.id === item.id;
            });
            if (!arr || arr.length < 1) {
              this.faultSelected.push(element);
            }
          }
          if (element.child) {
            this.setSelect(element.child);
          }
        }
      }
      let _length = this.faultTableData.length;
      for (let i = 0; i < this.faultTableData.length; i++) {
        _length += this.faultTableData[i].child.length;
      }
      if (this.faultSelected.length === _length) {
        this.faultSelectedAll = true;
        this.isIndeterminate = false;
      } else if (this.faultSelected.length === 0) {
        this.faultSelectedAll = false;
        this.isIndeterminate = false;
      } else {
        this.faultSelectedAll = false;
        this.isIndeterminate = true;
      }
    }
  }
  private searchFault() {
    this.currentPage = 1;
    this.getList();
  }
  private clearSearchFault() {
    this.currentPage = 1;
    this.faultSearch.name = '';
    this.getList();
  }
  private closeFaultHandle(val: any, index:any) {
    this.faultTopMultipleSelection.splice(index, 1);
    let removeIndex = this.faultSelected.findIndex((faultItem:any)=>{
      return val.id === faultItem.id
    })
    if(removeIndex!==-1){
      this.faultSelected.splice(removeIndex,1);
    }
    
    let checkedCount = this.faultSelected.length;
    let _length = this.faultTableData.length;
    for (let i = 0; i < this.faultTableData.length; i++) {
      if (this.faultTableData[i].child) {
        _length += this.faultTableData[i].child.length;
      }
    }
    this.faultSelectedAll = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
  }
  private checkAllFaultChange(val: any) {
    let faultOptions:any = [];
    if (val) {
      this.faultTableData.forEach((element:any) => {
        faultOptions.push(element);
      });
    }
    this.faultTopMultipleSelection = faultOptions;
    this.faultSelected = faultOptions;

    this.isIndeterminate = this.faultSelected.length === this.faultTopMultipleSelection.length;

    this.$emit('checkedFaultChange', this.faultTopMultipleSelection);
  }
  private checkedFaultChange(row: any) {
    //原有逻辑保留
    if(this.isMulti){
      let checkedCount = this.faultSelected.length;
      let _length = this.faultTableData.length;

      for (let i = 0; i < this.faultTableData.length; i++) {
        if (this.faultTableData[i].child) {
          _length += this.faultTableData[i].child.length;
        }
      }
      this.faultSelectedAll = checkedCount === _length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
      let arr = this.faultSelected.filter((device:any) => {
        return device.id === row.id
      })
      if (arr && arr.length > 0) {
        this.faultTopMultipleSelection.push(row)
      } else {
        let index = this.faultTopMultipleSelection.findIndex((v:any) => {
          return v.id === row.id
        })
        // findIndex 返回-1（未找到元素）
        if (index > -1) {
          this.faultTopMultipleSelection.splice(index, 1)
        }
      }
    }else{
      this.faultSelected = [row];
      this.faultTopMultipleSelection = [row];
    }
    this.$emit('checkedFaultChange', this.faultTopMultipleSelection);
  }
}
